const executeIfLoginScreen = () => {
	const loginSection = document.querySelector('section.for-login');
	if (loginSection) {
		sessionStorage.removeItem('hasCalledCheckDefaultCompany');
	} else {
		return;
	}
}
// essa funçao ira verificar se está na rota app/connect-iot ou se na rota tem login?redirect-to=%2Fapp%2Fconnect-iot se tiver ele ira redirecionar para a rota login-connect-iot
const checkRouteIfConnectIot = () => {
	if (window.location.search.includes('redirect-to=%2Fapp%2Fconnect-iot')) {
		window.location.href = '/login-connect-iot';
	}
}

checkRouteIfConnectIot();
executeIfLoginScreen(); 

